<template>
   <header id="site-header" class="fixed-top">
        <div class="container-fluid">
            <nav class="navbar navbar-expand-lg stroke">
                <h1>
                    <router-link class="navbar-brand d-flex align-items-center" to="/">
                        <img src="@/assets/images/logo.jpg" alt="That's Chinese Logo" class="mr-1" style="height: 40px;" />That's Chinese
                    </router-link>
                </h1>
                <!-- if logo is image enable this   
    <a class="navbar-brand" href="#home.html">
        <img src="image-path" alt="Your logo" title="Your logo" style="height:35px;" />
    </a> -->
                <button class="navbar-toggler  collapsed bg-gradient" type="button" data-toggle="collapse" data-target="#navbarTogglerDemo02" aria-controls="navbarTogglerDemo02" aria-expanded="false" aria-label="Toggle navigation">
                    <span class="navbar-toggler-icon fa icon-expand fa-bars"></span>
                    <span class="navbar-toggler-icon fa icon-close fa-times"></span>
                </button>

                <div class="collapse navbar-collapse" id="navbarTogglerDemo02">
                    <ul class="navbar-nav ml-lg-auto">
                        <li class="nav-item">
                          <router-link class="nav-link" to="/" exact active-class="active">Home</router-link>
                        </li>
                        <li class="nav-item">
                          <router-link class="nav-link" to="/about" active-class="active">About</router-link>
                        </li>
                        <li class="nav-item">
                          <router-link class="nav-link" to="/courses" active-class="active">Courses</router-link>
                        </li>
                        <li class="nav-item">
                          <router-link class="nav-link" to="/contact" active-class="active">Contact</router-link>
                        </li>
                        <!-- search button -->

                        <!-- //search button -->
                    </ul>
                </div>
                <!-- toggle switch for light and dark theme -->
                <div class="cont-ser-position">
                    <nav class="navigation">
                        <div class="theme-switch-wrapper">
                            <label class="theme-switch" for="checkbox">
                                <input type="checkbox" id="checkbox" @change="toggleTheme">
                                <div class="mode-container">
                                    <i class="gg-sun"></i>
                                    <i class="gg-moon"></i>
                                </div>
                            </label>
                        </div>
                    </nav>
                </div>
                <!-- //toggle switch for light and dark theme -->
            </nav>
        </div>
    </header>
</template>

<script>
export default {
  name: 'SiteHeader',
  mounted() {
    window.addEventListener('scroll', this.handleScroll);

    // 设置默认主题为 dark
    let currentTheme = localStorage.getItem('theme');
    if (!currentTheme) {
      currentTheme = 'dark'; // 默认设置为 dark
      localStorage.setItem('theme', currentTheme);
    }

    document.documentElement.setAttribute('data-theme', currentTheme);
    document.getElementById('checkbox').checked = currentTheme === 'dark';
  },
  beforeUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    handleScroll() {
      const header = document.getElementById('site-header');
      if (header) {
        if (window.scrollY >= 80) {
          header.classList.add('nav-fixed');
        } else {
          header.classList.remove('nav-fixed');
        }
      }
    },
    toggleTheme(event) {
      const isDark = event.target.checked;
      document.documentElement.setAttribute('data-theme', isDark ? 'dark' : 'light');
      localStorage.setItem('theme', isDark ? 'dark' : 'light');
    }
  }
}
</script>

<style scoped>
.nav-link.active {
  color: #ff6e65 !important;
  font-weight: 600;
}

.nav-link {
  color: var(--text-color);
  transition: color 0.3s ease;
}

.nav-link:hover {
  color: #ff6e65;
}
</style> 